// extracted by mini-css-extract-plugin
export const posts = "post-module--posts--uDb8l";
export const post = "post-module--post--2jvnJ";
export const header = "post-module--header--1QKMG";
export const title = "post-module--title--ZW2_V";
export const date = "post-module--date--26MUs";
export const featureImage = "post-module--featureImage--3BFqJ";
export const button = "post-module--button--3WW1r";
export const metas = "post-module--metas--2h_eX";